module.exports = {
  master_sandbox: {
    title: '蜂寻',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    // REDIRECT_URL: 'http://twe.vaiwan.com:8081/login',
    // APP_ID: 'dingoazohltk6won6xa6cx',
    REDIRECT_URL: 'https://dt-sandbox.biz.work/login',
    APP_ID: 'dingoa8hvo1n109xqv2a7a',
    DTSCAN_URL: 'dt-sandbox.biz.work',
    MAIN_URL: 'sandbox.biz.work',
    theme: '#41bfbf',
    socket_url: 'https://test.lixiaoskb.com'
    // socket_url: 'http://192.168.1.101:7200'
  },
  master_online: {
    title: '蜂寻',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    APP_ID: 'dingoauyhoc8sfjhqukggm',
    DTSCAN_URL: 'dt.biz.work',
    MAIN_URL: 'biz.work',
    theme: '#41bfbf',
    socket_url: 'https://biz.work'
  },
  master_dev: {
    title: '蜂寻',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    // REDIRECT_URL: 'http://twe.vaiwan.com:8081/login',
    // APP_ID: 'dingoazohltk6won6xa6cx',
    REDIRECT_URL: 'https://dev.lixiaoskb.com/login',
    APP_ID: 'dingoa8hvo1n109xqv2a7a',
    DTSCAN_URL: 'dev.lixiaoskb.com',
    MAIN_URL: 'dev.lixiaoskb.com',
    theme: '#41bfbf',
    socket_url: 'https://dev.lixiaoskb.com'
  },
  sokebao_sandbox: {
    title: '',
    keywords: '',
    description: '',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    theme: '#41bfbf',
    socket_url: 'https://test.lixiaoskb.com',
    newSkbLoginUrl:
      'https://uc-test.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab#/lxyunLogin',
    newSkbRegistUrl:
      'https://uc-test.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab&registered_way=normal_source&archType=productAndModule#/signUp',
    cmsHost: 'https://cms.ikcrm.com',
    lxyHost: 'https://www.lixiaoyun.com'
  },
  sokebao_stage: {
    title: '',
    keywords: '',
    description: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'default',
    theme: '#41bfbf',
    socket_url: 'https://stage.lixiaoskb.com',
    newSkbLoginUrl:
      'https://uc-staging.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab#/lxyunLogin',
    newSkbRegistUrl:
      'https://uc-staging.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab&registered_way=normal_source&archType=productAndModule#/signUp',
    cmsHost: 'https://cms.ikcrm.com',
    lxyHost: 'https://www.lixiaoyun.com'
  },
  sokebao_online: {
    title: '',
    keywords: '',
    description: '',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    theme: '#41bfbf',
    socket_url: 'https://biz.lixiaoskb.com',
    newSkbLoginUrl:
      'https://uc.weiwenjia.com/web/index.html?appToken=a14cc8b00f84e64b438af540390531e4#/lxyunLogin',
    newSkbRegistUrl:
      'https://uc.weiwenjia.com/web/index.html?appToken=a14cc8b00f84e64b438af540390531e4&archType=productAndModule#/signUp',
    cmsHost: 'https://cms.ikcrm.com',
    lxyHost: 'https://www.lixiaoyun.com'
  },
  sokebao_dev: {
    title: '',
    keywords: '',
    description: '',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    theme: '#41bfbf',
    socket_url: 'https://dev.lixiaoskb.com',
    newSkbLoginUrl:
      'https://uc-test.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab#/lxyunLogin',
    newSkbRegistUrl:
      'https://uc-test.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab&registered_way=normal_source&archType=productAndModule#/signUp',
    cmsHost: 'https://cms.ikcrm.com',
    lxyHost: 'https://www.lixiaoyun.com'
  },

  sokebao_seo_sandbox: {
    title: '励销搜客宝-微问家旗下知名品牌,To B企业获客利器|励销云系列产品',
    keywords:
      '搜客宝，励销搜客宝，励销云，搜客宝官网，励销搜客宝官网，销售管理软件，智能获客软件，智能销售软件，智能营销软件，电销软件',
    description:
      '励销搜客宝是一款结合人工智能与大数据应用的To B企业智能获客利器,可对接励销电话机器人、励销CRM，实现“找客户、筛客户、管客户”一站式销售赋能',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    theme: '#41bfbf',
    socket_url: 'https://test.lixiaoskb.com',
    newSkbLoginUrl:
      'https://uc-test.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab#/lxyunLogin',
    newSkbRegistUrl:
      'https://uc-test.weiwenjia.com/web/index.html?appToken=f6620ff6729345c8b6101174e695d0ab&registered_way=normal_source&archType=productAndModule#/signUp',
    cmsHost: 'https://cms.ikcrm.com',
    lxyHost: 'https://www.lixiaoyun.com'
  },
  sokebao_seo_online: {
    title: '励销搜客宝-微问家旗下知名品牌,To B企业获客利器|励销云系列产品',
    keywords:
      '搜客宝，励销搜客宝，励销云，搜客宝官网，励销搜客宝官网，销售管理软件，智能获客软件，智能销售软件，智能营销软件，电销软件',
    description:
      '励销搜客宝是一款结合人工智能与大数据应用的To B企业智能获客利器,可对接励销电话机器人、励销CRM，实现“找客户、筛客户、管客户”一站式销售赋能',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    theme: '#41bfbf',
    socket_url: 'https://biz.lixiaoskb.com',
    newSkbLoginUrl:
      'https://uc.weiwenjia.com/web/index.html?appToken=a14cc8b00f84e64b438af540390531e4#/lxyunLogin',
    newSkbRegistUrl:
      'https://uc.weiwenjia.com/web/index.html?appToken=a14cc8b00f84e64b438af540390531e4&archType=productAndModule#/signUp',
    cmsHost: 'https://cms.ikcrm.com',
    lxyHost: 'https://www.lixiaoyun.com'
  },

  dt_sandbox: {
    title: '蜂寻',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    REDIRECT_URL: 'https://dt-sandbox.biz.work/login',
    APP_ID: 'dingoa8hvo1n109xqv2a7a',
    DTSCAN_URL: 'dt-sandbox.biz.work',
    MAIN_URL: 'sandbox.biz.work',
    theme: '#41bfbf',
    socket_url: 'https://sandbox.biz.work'
  },
  dt_stage: {
    title: '蜂寻',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'stage',
    REDIRECT_URL: 'https://dt-stage.biz.work/login',
    APP_ID: 'dingoauyhoc8sfjhqukggm',
    DTSCAN_URL: 'dt-stage.biz.work',
    MAIN_URL: 'stage.biz.work',
    theme: '#41bfbf',
    socket_url: 'https://stage.biz.work'
  },
  dt_online: {
    title: '蜂寻',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    REDIRECT_URL: 'https://dt.biz.work/login',
    APP_ID: 'dingoaxf5kuymxjpba1yhq',
    DTSCAN_URL: 'dt.biz.work',
    MAIN_URL: 'biz.work',
    theme: '#41bfbf',
    socket_url: 'https://biz.work'
  },
  hq_sandbox: {
    title: 'OMS',
    favicon: './static/img/favicon-hq.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'production',
    REDIRECT_URL: 'https://ptest.hecom.cn/cusweb/dist/externalx.html',
    APP_ID: 'dingoaxf5kuymxjpba1yhq',
    DTSCAN_URL: 'https://ptest.hecom.cn/cusweb/dist/login.html',
    MAIN_URL: 'biz.work',
    theme: '#E15151',
    socket_url: 'https://test.lixiaoskb.com'
  },
  hq_stage: {
    title: 'OMS',
    favicon: './static/img/favicon-hq.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'production',
    REDIRECT_URL: 'https://ptest.hecom.cn/cusweb/dist/externalx.html',
    APP_ID: '',
    DTSCAN_URL: 'https://ptest.hecom.cn/cusweb/dist/login.html',
    MAIN_URL: '',
    theme: '#E15151',
    socket_url: 'https://test.lixiaoskb.com'
  },
  hq_online: {
    title: 'OMS',
    favicon: './static/img/favicon-hq.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    REDIRECT_URL: 'https://vip.hecom.cn/externalx.html',
    APP_ID: '',
    DTSCAN_URL: 'https://vip.hecom.cn/login.html',
    MAIN_URL: '',
    theme: '#E15151',
    socket_url: 'https://test.lixiaoskb.com'
  },

  kjn_sandbox: {
    title: '跨境牛',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'default',
    REDIRECT_URL: '',
    APP_ID: '',
    DTSCAN_URL: '',
    socket_url: 'https://kjn-test.lixiaoskb.com',
    MAIN_URL: '',
    theme: '#E15151'
  },
  kjn_stage: {
    title: '跨境牛',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'default',
    REDIRECT_URL: '',
    APP_ID: '',
    DTSCAN_URL: '',
    socket_url: 'https://kjn-stage.lixiaoskb.com',
    MAIN_URL: '',
    theme: '#E15151'
  },
  kjn_online: {
    title: '跨境牛',
    favicon: '',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    REDIRECT_URL: '',
    APP_ID: '',
    DTSCAN_URL: '',
    socket_url: 'https://kjn.lixiaoskb.com',
    MAIN_URL: '',
    theme: '#E15151'
  },
  // sdsw
  sdsw_sandbox: {
    title: '尚启数据',
    favicon: './static/img/favicon-sdsw.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    APP_ID: '',
    REDIRECT_URL: '',
    DTSCAN_URL: '',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'https://test.lixiaoskb.com'
  },
  sdsw_stage: {
    title: '尚启数据',
    favicon: './static/img/favicon-sdsw.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'default',
    APP_ID: '',
    REDIRECT_URL: '',
    DTSCAN_URL: '',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'https://sdsw-stage.lixiaoskb.com'
  },
  sdsw_online: {
    title: '尚启数据',
    favicon: './static/img/favicon-sdsw.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    APP_ID: '',
    REDIRECT_URL: '',
    DTSCAN_URL: '',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'http://www.shangweitianxia.cn'
  },
  yqx_sandbox: {
    title: '连源信息',
    favicon: './static/img/favicon-ly.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'default',
    APP_ID: '',
    REDIRECT_URL: 'https://integration-stage.lixiaoskb.com',
    DTSCAN_URL: 'https://integration-stage.lixiaoskb.com',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'https://integration-stage.lixiaoskb.com'
  },
  yqx_online: {
    title: '连源信息',
    favicon: './static/img/favicon-ly.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    APP_ID: '',
    REDIRECT_URL: 'https://integration.lixiaoskb.com',
    DTSCAN_URL: 'https://integration.lixiaoskb.com',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'https://integration.lixiaoskb.com'
  },

  //九鹿林电销工厂
  jll_sandbox: {
    title: '电销工厂',
    favicon: './static/img/favicon-jll.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?67220bace7f8f3cf3e6a5064454a6a05',
    project: 'default',
    APP_ID: '',
    REDIRECT_URL: '',
    DTSCAN_URL: '',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'https://test.lixiaoskb.com'
  },
  jll_stage: {
    title: '电销工厂',
    favicon: './static/img/favicon-jll.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'default',
    APP_ID: '',
    REDIRECT_URL: '',
    DTSCAN_URL: '',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'https://sdsw-stage.lixiaoskb.com'
  },
  jll_online: {
    title: '电销工厂',
    favicon: './static/img/favicon-jll.ico',
    baiduurl: 'https://hm.baidu.com/hm.js?d59468a96a38e5634623a27728438fc4',
    project: 'production',
    APP_ID: '',
    REDIRECT_URL: '',
    DTSCAN_URL: '',
    MAIN_URL: '',
    theme: '#41bfbf',
    socket_url: 'http://dianxiao.jiululin.cn/login'
  }
};



//////////////////
// WEBPACK FOOTER
// ./config/html.js
// module id = rLw9
// module chunks = 30